import cn from "classnames";
import { Skeleton } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
var LastActivityCourseCardSkeleton = function LastActivityCourseCardSkeleton(_ref) {
  var className = _ref.className,
    isDark = _ref.isDark;
  return /*#__PURE__*/_jsx(Skeleton, {
    className: cn('w-full h-full flex flex-col rounded-5', className),
    style: {
      minHeight: '280px'
    },
    isDark: isDark
  });
};
export default LastActivityCourseCardSkeleton;